import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-scroll-container',
  templateUrl: './scroll-container.component.html',
  styleUrl: './scroll-container.component.css'
})
export class ScrollContainerComponent {
  @ViewChild('content') content!: ElementRef<HTMLDivElement>;
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal';
  @Input() step = 300;
  @Input() showButtons = true;

  canScroll = false;
  canGoPrevious = false;
  canGoNext = false;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.updateState();
    });
    const resizeObserver = new ResizeObserver(() => {
      this.updateState();
    });
    resizeObserver.observe(this.content.nativeElement);
  }

  @HostListener('window:resize') onResize() {
    this.updateState();
  }

  onScroll() {
    this.updateState();
  }

  previous() {
    const el = this.content.nativeElement;
    el.scrollBy({
      left: this.orientation === 'horizontal' ? -this.step : 0,
      top: this.orientation === 'vertical' ? -this.step : 0,
      behavior: 'smooth'
    });
  }

  next() {
    const el = this.content.nativeElement;
    el.scrollBy({
      left: this.orientation === 'horizontal' ? this.step : 0,
      top: this.orientation === 'vertical' ? this.step : 0,
      behavior: 'smooth'
    });
  }

  private updateState() {
    const el = this.content.nativeElement;
    if (this.orientation === 'horizontal') {
      this.canScroll = el.scrollWidth > el.clientWidth;
      this.canGoPrevious = el.scrollLeft > 0;
      this.canGoNext = el.scrollLeft + el.clientWidth < el.scrollWidth - 1;
    } else {
      this.canScroll = el.scrollHeight > el.clientHeight;
      this.canGoPrevious = el.scrollTop > 0;
      this.canGoNext = el.scrollTop + el.clientHeight < el.scrollHeight - 1;
    }
  }
}
